import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import apiInstance from "../../../apiInstance";
import { useNavigate } from "react-router-dom";
import PopupModal from "../../popups/PopupModal";

const Subscriptions = () => {
    const user = useSelector((state) => state.currentUser);
    const [subscriptions, setSubscriptions] = useState([]);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const popupRef = useRef();

    const updateSubscriptionHandler = (sub) => {
        setSubscriptions(prev => prev.map(item => item.id === sub._id ? {...item, ...sub} : item));
    }

    useEffect(() => {
        const fetchUserSubscriptions = async () => {
            apiInstance
                .get(`/dashboard/subscription`, {
                    params: {
                        user: user.id,
                    },
                })
                .then((response) => {
                    const fetchedSubs = response.data.subscriptions || [];
                    setSubscriptions(fetchedSubs);
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load subscriptions.");
                });
        };

        fetchUserSubscriptions();
    }, [user.id]);
	
	const pricing_amount = process.env.REACT_APP_STRIPE_MONTHLY_PRICING;

    return (
        <div className="mjs-dash-section">
            <div className="mjs-dash-sec-header">
                <h4>Subscriptions</h4>
            </div>
            <div className="mjs-dash-inner-container">
                <table className="mjs-table hover-enabled">
                    <thead>
                        <tr>
                            <th>Site Name</th>
                            <th>Status</th>                            
                            <th>Amount($)</th>
                            <th>Start Date</th>
                            <th>Renewal Date</th>
                            <th>Payment Method</th>
                            <th></th>
                        </tr>
                    </thead>
                    {subscriptions.length > 0 ? (
                        <tbody>
                            {subscriptions.map((sub, index) => (
                                <tr
                                    key={sub.id}
                                    onClick={() =>
                                        navigate(
                                            `/billing/subscriptions/${sub.id}`
                                        )
                                    }
                                >
                                    <td>{sub?.subType ? sub?.siteName + " - " + sub.subType : sub.siteName || "--"}</td>
                                    <td>{sub?.paused ? 'Cancelled' : (sub?.status || "-")}</td>
                                    <td>{sub?.amount || pricing_amount}</td>
                                    <td>
                                        {sub.createdAt
                                            ? new Date(
                                                  sub.createdAt
                                              ).toDateString()
                                            : "—"}
                                    </td>
                                    <td>
                                        {sub.currentPeriodEnd
                                            ? new Date(
                                                  sub.currentPeriodEnd
                                              ).toDateString()
                                            : "—"}
                                    </td>
                                    <td>
                                        {(sub.status === 'active' || sub.status === "past_due") &&
                                            <i 
                                                title="Update payment method" 
                                                class="fa-solid fa-pen-to-square mjs-cursor-pointer"
                                                style={{marginRight: '10px'}}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    popupRef.current?.openPopup("changePaymentMethod", { subscriptionId: sub._id });
                                                }}  
                                            ></i>
                                        }
                                        {sub?.defaultPaymentMethod?.detail || "-"}
                                    </td>
                                    <td className="mjs-table-actions">
                                        <button
                                            className={`mjs-btn ${sub.paused ? 'disabled': ''}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                popupRef.current?.openPopup("deleteSubscription", { subscription: sub });
                                            }}
                                            disabled={sub.paused || sub.status === 'canceled'}
                                        >Cancel</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="8" className="mjs-msg">
                                    No subscriptions found.
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
            <PopupModal
                ref={popupRef}
                updateSubscription={updateSubscriptionHandler}
            />
            <div className="mjs-error">{error}</div>
        </div>
    );
};

export default Subscriptions;
